import { useEffect, useState } from 'react';
import { Box, Grid, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../hooks/useIsMobile';
import SearchToolbar from '../../components/SearchToolbar/SearchToolbar';
import SectionHeader from '../../components/SectionHeader';
import { PeriodicosFilters } from './components/PeriodicosFilters';
import ExposedGrid from './components/ExposedGrid';
import { useResultados } from './hooks/useResultados';
import PeriodicosDrawerManager, {
    PERIODICOS_DRAWER_ACTION_VALUES
} from './components/PeriodicosDrawerManager';
import { Menu, MenuItem } from '@mui/material';

const ResultadosIndex = () => {
    const { t } = useTranslation('periodicos');
    const { isMobile, isTablet } = useIsMobile();

    const {
        handleSearch,
        handleClearFilters,
        handleChangeExtraFilters,
        extraFilters,
        filters,
        setFilters,
        isFetching,
        fetchData,
        selectedEmployee,
        handleSelectEmployee,
        handleClickAction,
        getUniqueId,
        getColumnWidths,
        open,
        setOpen,
        reloadGrid
    } = useResultados();

    const [isLoading, setIsLoading] = useState(true);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>, employee: any) => {
        setAnchorEl(event.currentTarget);
        handleClickAction(employee);
        setMenuOpen(true);
    };

    const handleCloseMenu = () => {
        setMenuOpen(false);
        setAnchorEl(null);
    };

    useEffect(() => {
        handleSearch().finally(() => setIsLoading(false));
    }, []);

    const headerTitle = t('header.title.results');

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <SectionHeader>
                        <SectionHeader.Title>{headerTitle}</SectionHeader.Title>
                    </SectionHeader>
                </Grid>

                <Grid item xs={12}>
                    <SearchToolbar
                        inputSearchName=""
                        onChange={() => {}}
                        onClick={handleSearch}
                        showSearchInput={false}
                        clearFilters={handleClearFilters}
                    >
                        <PeriodicosFilters
                            extraFilters={extraFilters}
                            handleChangeExtraFilters={handleChangeExtraFilters}
                            reconfirmation={true}
                            tabIndex={5}
                        />
                    </SearchToolbar>
                </Grid>
            </Grid>

            <Grid container justifyContent="center" alignItems="flex-start" spacing={3}>
                <Grid item xs={12} lg={12}>
                    <Box sx={{ mb: 2 }}>
                        {isLoading || isFetching ? (
                            <Box display="flex" justifyContent="center" mt={4}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <ExposedGrid
                                tabIndex={5}
                                items={fetchData}
                                filters={filters}
                                setFilters={setFilters}
                                isFetching={isFetching}
                                selectedEmployee={selectedEmployee}
                                selectedIds={[]}
                                handleSelectEmployee={handleSelectEmployee}
                                handleClickAction={(event: any, employee: any) =>
                                    handleOpenMenu(event, employee)
                                }
                                handleSelectAllEmployed={() => {}}
                                getUniqueIdByTabIndex={getUniqueId}
                                getColumnWidths={getColumnWidths}
                            />
                        )}
                    </Box>
                </Grid>
                <Menu
                    id="resultados-menu"
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleCloseMenu}
                >
                    <MenuItem
                        onClick={() => {
                            handleCloseMenu();
                            setOpen(PERIODICOS_DRAWER_ACTION_VALUES.VIEW_DETAILS_HISTORY);
                        }}
                    >
                        {t('table.actions.seeHistory')}
                    </MenuItem>
                </Menu>
            </Grid>

            <PeriodicosDrawerManager
                open={open}
                setOpen={setOpen}
                selectedIds={[]}
                reloadGrid={reloadGrid}
                selectedEmployee={selectedEmployee}
                reloadCurrentTab={handleSearch}
                tabIndex={0}
            />
        </>
    );
};

export default ResultadosIndex;
